export const START_OFFLINE_MODE = 'START_OFFLINE_MODE';
export const TRY_START_ONLINE_MODE = 'TRY_START_ONLINE_MODE';
export const START_ONLINE_MODE = 'START_ONLINE_MODE';
